var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm.classObject},[(_vm.dismissible)?_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-hidden":"true"}},[_vm._v(" × ")]):_vm._e(),_vm._t("header"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }